
import { Vue, Component, Ref } from 'vue-property-decorator'

import ListView from '@/components/ListView.vue'
import DateSelect from '@/components/DateSelect.vue'
import { DynamicPricingImportLog } from '@/types'

@Component({
  components: { ListView, DateSelect },
})
export default class DynamicPricingListPage extends Vue {
  @Ref() readonly listView!: ListView
  filterDefinition = {
    ordering: { type: String, default: '-created' },
    dateFrom: { type: String, default: null },
    dateTo: { type: String, default: null },
    shop: { type: String, default: null },
  }
  filter: null | Record<string, any> = null
  headers = [
    { text: 'ID', value: 'id' },
    { text: 'ファイル名', value: 'originalFilename' },
    { text: 'ステータス', value: 'statusDisplay' },
    { text: '登録件数', value: 'imported' },
    { text: '作成者', value: 'createdUsername' },
    { text: '登録日時', value: 'created' },
    { text: '更新日時', value: 'updated' },
    { text: '操作', value: 'actions' },
  ]

  uploadDialog = false
  rowErrors: Array<{ row: number; message: string }> = []
  uploadFile: File | null = null

  updateQuery() {
    if (this.filter !== null) this.listView.updateQuery(this.filter)
  }

  openUploadDialog() {
    this.rowErrors = []
    this.uploadFile = null
    this.uploadDialog = true
  }

  onFileChange() {
    this.rowErrors = []
  }

  async upload() {
    this.rowErrors = []
    try {
      if (!this.uploadFile) {
        alert('ファイルを選択してください')
        return
      }
      const formData = new FormData()
      formData.append('file', this.uploadFile)
      await this.$api.dynamicPricing.importLogs().create(formData)
      this.$toast.success('アップロードしました。')
      this.listView.reload()
      this.uploadDialog = false
    } catch (err: any) {
      const data = err.response?.data
      if (data?.rowErrors) {
        this.rowErrors = data.rowErrors // CSV各行のバリデーションエラー（行番号つき）
      } else if (data?.detail) {
        this.$toast.error(data.detail)
      } else {
        this.$toast.error('アップロードに失敗しました。')
      }
    }
    this.uploadFile = null
  }

  async apply(item: DynamicPricingImportLog) {
    if (item.status !== 0) {
      this.$toast.error('即時反映は処理待ちデータのみ実行できます。')
      return
    }
    if (confirm('このファイルを即時反映しますか？')) {
      await this.$api.dynamicPricing.importLogs(item.id).apply()
      this.listView.reload()
    }
  }

  async cancel(item: DynamicPricingImportLog) {
    if (item.status !== 0) {
      this.$toast.error('キャンセルは処理待ちデータのみ実行できます。')
      return
    }
    if (confirm('このファイルの取り込みをキャンセルしますか？')) {
      await this.$api.dynamicPricing.importLogs(item.id).cancel()
      this.listView.reload()
    }
  }
}
